"use strict";
/**declare var libGlobal: any;
const libR = window.libR;*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var zpdes_tools_1 = require("./zpdes_tools");
var zpdes_tools_2 = require("./zpdes_tools");
var zpdes_tools_3 = require("./zpdes_tools");
var zpdes_tools_4 = require("./zpdes_tools");
//import cloneDeep = require('lodash/cloneDeep');
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
//import { deepCopy } from "./zpdes_tools";
//import { range } from "./zpdes_tools";
//import { zip } from "./zpdes_tools";
/***********************************************************************
/* Blocking function : prof to disable module.
***********************************************************************/
var ZpdesHssbg = /** @class */ (function () {
    /**
    * Constructor of hssbg class
     * hssbg means hierarchical strategic student bandit group. It's the main class that manages all bandit groups.
    * @param params all parameters for hssbg coming from config files
    */
    function ZpdesHssbg(params) {
        this.godmode = false;
        this.params = params;
        this.act_sequence = {}; // act_sequence is used to keep track of student's history for student diagnostic
        this.act_sequence["seq"] = [];
        this.act_sequence["res"] = [];
        this.act_sequence["ex"] = [];
        this.act_sequence["act"] = [];
        this.act_sequence["timestamp"] = [];
        this.act_sequence["duration"] = [];
        this.main_act = this.params["graph"]["main_act"]; // this is the module id
        var graph_def = this.params["graph"]["graph"];
        // if("act_prime" in graph_infos)
        //     graph_def = graph_infos;
        // else:
        //     graph_def = func.load_json(graph_infos["file_name"], graph_infos["path"]);
        //if("competencies" in graph_def){
        //    this.competencies = graph_def["competencies"];
        //    this.ncompetencies = this.competencies.length;
        //}
        //else if("ncompetencies" in graph_def){
        //    this.ncompetencies = graph_def["ncompetencies"];
        //    this.competencies = [];
        //}
        //else{
        //    this.competencies = [];
        //    this.ncompetencies = 1;
        //} 
        // Start of ssbgs initialisation
        graph_def["current_ssbg"] = graph_def["act_prime"];
        var ssbg_params = this.params["ZpdesSsbg"];
        ssbg_params["graph_def"] = graph_def;
        // Maybe to integrate to addSSBG method eventually
        //this.expected_actual_progression_speed = {};
        //for(let i=0;i < this.params["graph"]["graph"][this.main_act]["subgroups"][0].length;i++){
        //    this.expected_actual_progression_speed[this.params["graph"]["graph"][this.main_act]["subgroups"][0][i]] = [];
        //}
        // Below, this is where we instantiate/define the ZPDES based on the prerequisites graph. It works recursively.
        var mainSSBG = this.instantiate_ssbg(graph_def);
        this.SSBGs = {};
        this.SSBGs[this.main_act] = mainSSBG;
        this.addSSBG(this.SSBGs[this.main_act], graph_def);
        this.add_requirements();
        // Get number of different activities in the graph: used to get graph coverage rate in student diagnostic
        this.nbOfUniqueActivities = 0;
        for (var i = 0; i < this.params["graph"]["graph"][this.main_act]["subgroups"][0].length; i++) {
            var objId = this.params["graph"]["graph"][this.main_act]["subgroups"][0][i];
            this.nbOfUniqueActivities += this.params["graph"]["graph"][objId]["subgroups"][0].length;
        }
        this.exercises_ontology = this.params["graph"]["exercises_ontology"]; // same structure as in the ontology on circle ci
        // Create dictionary of exercises to pick in after choosing the activity
        this.exercises_to_pick_in = {};
        this.fewLastExercises = {}; // Used to prevent the algorithm to select the same exercise too close from the last time
        for (var key in this.exercises_ontology) {
            this.exercises_to_pick_in[this.exercises_ontology[key]["id"]] = new Set();
            this.fewLastExercises[this.exercises_ontology[key]["id"]] = [];
            for (var val in this.exercises_ontology[key]["exerciseIds"]) {
                var ex_id = this.exercises_ontology[key]["exerciseIds"][val];
                this.exercises_to_pick_in[this.exercises_ontology[key]["id"]].add(ex_id);
            }
        }
        this.initialTestMetadata = this.params["graph"]["initialTest"];
        this.exercisesMetaData = this.params["graph"]["exercisesMetaData"];
    }
    /**
    * Setter of God Mod: unused for now in Athena
    * @param mod_input value of godmode
    */
    ZpdesHssbg.prototype.set_god_mode = function (mod_input) {
        if (mod_input === void 0) { mod_input = false; }
        this.godmode = mod_input;
        for (var ID in this.SSBGs) {
            this.SSBGs[ID].set_god_mode(mod_input);
        }
    };
    /**
    * Setters of ssbg parameters: unused for now in Athena
    * @param graph_params graph_to_update
    */
    ZpdesHssbg.prototype.set_graph_params = function (graph_params, json_data_string) {
        var json_data = JSON.parse(json_data_string);
        var data_keys = Object.keys(json_data);
        var data_values = Object.values(json_data);
        for (var i = 0; i < data_keys.length; i++) {
            if (typeof (data_values[i]) == "object" && Array.isArray(data_values[i]) == false) {
                if (data_keys[i] == "params") {
                    this[data_keys[i]] = data_values[i];
                }
                if (data_keys[i] == "SSBGs") {
                    for (var _i = 0, _a = Object.keys(data_values[i]); _i < _a.length; _i++) {
                        var ssbgs_name = _a[_i];
                        this.SSBGs[ssbgs_name].json_load(data_values[i][ssbgs_name], this.SSBGs);
                    }
                }
            }
            else {
                this[data_keys[i]] = data_values[i];
            }
        }
    };
    ZpdesHssbg.prototype.change_graph_params = function (json_data_string) {
        var json_data = JSON.parse(json_data_string);
        var data_keys = Object.keys(json_data);
        var data_values = Object.values(json_data);
        for (var i = 0; i < data_keys.length; i++) {
            if (data_keys[i] != "act_prime") {
                this.SSBGs[data_keys[i]].change_params(data_values[i]);
            }
        }
    };
    /**
    * Function to save all of the alg state in json: unused for now in Athena (stateless)
    * @returns json data formatted
    */
    ZpdesHssbg.prototype.json_save = function () {
        var saved_json = {};
        var keys = Object.keys(this);
        var values = Object.values(this);
        for (var i = 0; i < keys.length; i++) {
            if (typeof (values[i]) == "object" && Array.isArray(values[i]) == false) {
                if (keys[i] == "params") {
                    saved_json[keys[i]] = values[i];
                }
                if (keys[i] == "SSBGs") {
                    var ssbgs_json = {};
                    for (var _i = 0, _a = Object.keys(values[i]); _i < _a.length; _i++) {
                        var ssbgs_name = _a[_i];
                        ssbgs_json[ssbgs_name] = this.SSBGs[ssbgs_name].json_save();
                    }
                    saved_json["SSBGs"] = ssbgs_json;
                }
                else {
                    saved_json[keys[i]] = values[i];
                }
            }
            else {
                saved_json[keys[i]] = values[i];
            }
        }
        var strjson = JSON.stringify(saved_json);
        return strjson;
    };
    /**
    * Function to load the full alg state from json format: unused for now in Athena (stateless)
    * @param json_data_string json data
    */
    ZpdesHssbg.prototype.json_load = function (json_data_string) {
        var json_data = JSON.parse(json_data_string);
        var data_keys = Object.keys(json_data);
        var data_values = Object.values(json_data);
        for (var i = 0; i < data_keys.length; i++) {
            if (typeof (data_values[i]) == "object" && Array.isArray(data_values[i]) == false) {
                if (data_keys[i] == "params") {
                    this[data_keys[i]] = data_values[i];
                }
                if (data_keys[i] == "SSBGs") {
                    for (var _i = 0, _a = Object.keys(data_values[i]); _i < _a.length; _i++) {
                        var ssbgs_name = _a[_i];
                        this.SSBGs[ssbgs_name].json_load(data_values[i][ssbgs_name], this.SSBGs);
                    }
                }
            }
            else {
                this[data_keys[i]] = data_values[i];
            }
        }
    };
    /**
    * Function to save the sequence of activities with results in json: unused for now in Athena (stateless)
    * @returns json data formatted
    */
    ZpdesHssbg.prototype.seq_json_save = function () {
        var saved_json = {};
        saved_json["act_sequence"] = this.act_sequence;
        var strjson = JSON.stringify(saved_json);
        return strjson;
    };
    /**
    * Function to load the alg state from sequence with result: unused for now in Athena (stateless)
    * @param json_data_string json data
    */
    ZpdesHssbg.prototype.seq_json_load = function (json_data_string) {
        var json_data = JSON.parse(json_data_string);
        var seq = json_data["act_sequence"]["seq"];
        var res = json_data["act_sequence"]["res"];
        for (var i = 0; i < seq.length; i++) {
            console.log(seq[i]);
            //this.update(seq[i], res[i]);
            this.update(__assign(__assign({}, seq), { "score": res })); // to check
        }
    };
    /**
    * Function to instante a bandit group to build the algorithm
    * @param graph_def definition of the graph from config file
    */
    ZpdesHssbg.prototype.instantiate_ssbg = function (graph_def) {
        var params = this.params["ZpdesSsbg"];
        params["graph_def"] = graph_def;
        return new ZpdesSsbg(params);
    };
    /**
    * Function used in constructor to generate recursively the tree view for bandit groups based on the config file
    * @param ssbg_father the bandit group which is added a sub bandit group
    * @param graph_def graph definition coming from the config file
    */
    ZpdesHssbg.prototype.addSSBG = function (ssbg_father, graph_def) {
        //let stuffZipped = zip(ssbg_father.param_values, ssbg_father.values_children); //, range(ssbg_father.param_values.length));
        for (var i = 0; i < ssbg_father.param_values.length; i++) {
            var actRT = ssbg_father.param_values[i];
            var hierarchy = ssbg_father.values_children[i];
            //let stuffZipped2 = zip(actRT, hierarchy);
            for (var ii = 0; ii < actRT.length; ii++) {
                var nameRT = actRT[ii];
                var hierar = hierarchy[ii];
                if (hierar && Object.keys(this.SSBGs).includes(nameRT)) {
                    ssbg_father.add_sonSSBG(i, this.SSBGs[nameRT]);
                }
                else if (hierar) {
                    graph_def["current_ssbg"] = nameRT;
                    //let nssbg = this.instantiate_ssbg(graph_def);
                    this.SSBGs[nameRT] = this.instantiate_ssbg(graph_def);
                    ssbg_father.add_sonSSBG(i, this.SSBGs[nameRT]);
                    this.addSSBG(this.SSBGs[nameRT], graph_def);
                }
            }
        }
    };
    /**
    Get full student progression diagnostic for the teacher dashboard.
    **/
    ZpdesHssbg.prototype.get_full_diagnostic = function () {
        var diagnostic_dict = {};
        diagnostic_dict["objectives"] = [];
        diagnostic_dict["param_state"] = {}; // param_state collects the states of the objectives and activities
        var timeSpentOnObjectives = {};
        for (var ID in this.SSBGs) {
            if (ID == this.main_act) { // this is the main module, so we're at the objective level here
                var moduleDiag = this.SSBGs[ID].get_student_diagnostic();
                //diagnostic_dict["module"] = moduleDiag["progression"]; // Uncomment if this info is needed later
                diagnostic_dict["param_state"][ID] = moduleDiag["param_state"]; // collects objectives states
            }
            else {
                var objectiveDiag = this.SSBGs[ID].get_student_diagnostic();
                timeSpentOnObjectives[ID] = 0;
                var beautifiedDiag = {
                    "id": ID,
                    "alert": "none",
                    "progression": [],
                    "status": "none",
                    "timeSpent": 0
                };
                diagnostic_dict["param_state"][ID] = objectiveDiag["param_state"]; // collects activities states
                // Beautify progression
                // TODO: there can be an issue here if at some point the student unlocks an activity from another objective
                var clonedObjectiveDiag = lodash_clonedeep_1.default(objectiveDiag);
                for (var i = 0; i < clonedObjectiveDiag["progression"].length; i++) {
                    var actId = this.params["graph"]["graph"][ID]["subgroups"][0][clonedObjectiveDiag["progression"][i]["id"]];
                    var beautifiedExercises = [];
                    // Beautify unlocked elements
                    for (var j = 0; j < clonedObjectiveDiag["progression"][i]["exercises"].length; j++) {
                        beautifiedExercises.push(clonedObjectiveDiag["progression"][i]["exercises"][j]);
                        var beautifiedUnlockedElements = [];
                        for (var l = 0; l < clonedObjectiveDiag["progression"][i]["exercises"][j]["unlockedElements"].length; l++) {
                            var unlockedActivityId = this.params["graph"]["graph"][ID]["subgroups"][0][clonedObjectiveDiag["progression"][i]["exercises"][j]["unlockedElements"][l]];
                            beautifiedUnlockedElements.push(unlockedActivityId);
                        }
                        beautifiedExercises[beautifiedExercises.length - 1]["unlockedElements"] = beautifiedUnlockedElements;
                    }
                    beautifiedDiag["progression"].push({
                        "id": actId,
                        "exercises": beautifiedExercises,
                        "status": clonedObjectiveDiag["progression"][i]["status"]
                    });
                }
                // Put an alert if there was any alert in the exercises of an objective
                var exercisesCounter = 0;
                var alertsCounter = { "positive": 0, "negative": 0, "total": 0 };
                for (var i = clonedObjectiveDiag["progression"].length - 1; i >= 0; i--) {
                    for (var j = clonedObjectiveDiag["progression"][i]["exercises"].length - 1; j >= 0; j--) {
                        if (clonedObjectiveDiag["progression"][i]["exercises"][j]["success"]["alert"] == "positive") {
                            alertsCounter["positive"] += 1;
                        }
                        else if (clonedObjectiveDiag["progression"][i]["exercises"][j]["success"]["alert"] == "negative") {
                            alertsCounter["negative"] += 1;
                        }
                        alertsCounter["total"] += 1;
                        exercisesCounter += 1;
                        //beautifiedDiag["alert"] = clonedObjectiveDiag["progression"][i]["exercises"][j]["success"]["alert"];
                        if (exercisesCounter >= 8) {
                            break;
                        }
                    }
                    if (exercisesCounter >= 8) {
                        break;
                    }
                }
                if (alertsCounter["negative"] / alertsCounter["total"] > 0.3) { // this could be parameterized
                    beautifiedDiag["alert"] = "negative";
                }
                else if (alertsCounter["positive"] / alertsCounter["total"] > 0.3) { // this too
                    beautifiedDiag["alert"] = "positive";
                }
                else {
                    beautifiedDiag["alert"] = "none";
                }
                diagnostic_dict["objectives"].push(beautifiedDiag);
            }
        }
        // Time spent on module and on objectives
        diagnostic_dict["timeSpent"] = {};
        for (var i = 0; i < this.act_sequence["timestamp"].length; i++) {
            if (this.act_sequence["timestamp"][i] != null) {
                var actTimestamp = new Date(this.act_sequence["timestamp"][i]);
                var readableTimestamp = actTimestamp.getFullYear() + '-' + (actTimestamp.getMonth() + 1) + '-' + actTimestamp.getDate();
                // Add duration to time spent on module
                if (Object.keys(diagnostic_dict["timeSpent"]).includes(readableTimestamp)) {
                    diagnostic_dict["timeSpent"][readableTimestamp] += this.act_sequence["duration"][i];
                }
                else {
                    diagnostic_dict["timeSpent"][readableTimestamp] = this.act_sequence["duration"][i];
                }
                // Add duration to time spent on objective
                var objectiveId = null; // TODO: make this cleaner
                for (var j = 0; j < this.params["graph"]["graph"][this.main_act]["subgroups"][0].length; j++) {
                    var obj_id = this.params["graph"]["graph"][this.main_act]["subgroups"][0][j];
                    if (this.params["graph"]["graph"][obj_id]["subgroups"][0].includes(this.act_sequence["act"][i])) {
                        objectiveId = obj_id;
                    }
                }
                if (Object.keys(timeSpentOnObjectives).includes(objectiveId)) {
                    // Back sends ZPDES integer durations (in seconds)
                    timeSpentOnObjectives[objectiveId] += this.act_sequence["duration"][i];
                }
            }
        }
        // Add time spent on objectives
        for (var i = 0; i < Object.keys(diagnostic_dict["objectives"]).length; i++) {
            diagnostic_dict["objectives"][i]["timeSpent"] = timeSpentOnObjectives[diagnostic_dict["objectives"][i]["id"]];
        }
        var lightDiagnosticDict = this.get_student_diagnostic();
        diagnostic_dict["mean_student_score"] = lightDiagnosticDict["mean_student_score"];
        diagnostic_dict["graphe_coverage_rate"] = lightDiagnosticDict["graphe_coverage_rate"];
        // Compute status variable
        //let initialTest = this.getInitialTestStatus();
        for (var i = 0; i < diagnostic_dict["param_state"][this.main_act][0].length; i++) {
            var objectiveId = this.params["graph"]["graph"][this.main_act]["subgroups"][0][i];
            for (var j = 0; j < diagnostic_dict["objectives"].length; j++) {
                if (diagnostic_dict["objectives"][j]["id"] == objectiveId) {
                    //if(!initialTest || diagnostic_dict["param_state"][this.main_act][0][i] == 0 || diagnostic_dict["objectives"][j]["progression"].length == 0){
                    if (diagnostic_dict["param_state"][this.main_act][0][i] == 0 || diagnostic_dict["objectives"][j]["progression"].length == 0) {
                        diagnostic_dict["objectives"][j]["status"] = "none";
                    }
                    else if (diagnostic_dict["param_state"][this.main_act][0][i] == 1) {
                        diagnostic_dict["objectives"][j]["status"] = "inProgress";
                    }
                    else {
                        diagnostic_dict["objectives"][j]["status"] = "completed";
                        diagnostic_dict["objectives"][j]["alert"] = "none"; // Remove alert is objective is completed
                    }
                }
            }
        }
        return diagnostic_dict;
    };
    /**
    Get lighter student progression diagnostic. Mainly useful for student's dashboard.
     TODO: the same name is used for this method and a diagnostic method in one of the classes below. It should be
     distinguished.
    **/
    ZpdesHssbg.prototype.get_student_diagnostic = function () {
        var diagnostic_dict = {};
        diagnostic_dict["mean_student_score"] = zpdes_tools_2.func_mean(this.act_sequence["res"]);
        // Compute graph coverage rate (percentage of unique activities already seen by the student)
        var alreadySeenActivities = new Set();
        for (var i = 0; i < this.act_sequence["act"].length; i++) {
            alreadySeenActivities.add(this.act_sequence["act"][i]);
        }
        diagnostic_dict["graphe_coverage_rate"] = zpdes_tools_3.truncate(alreadySeenActivities.size / this.nbOfUniqueActivities);
        return diagnostic_dict;
    };
    /**
    * Function used in the constructor to build the requirement for each bandit arm in each group
    */
    ZpdesHssbg.prototype.add_requirements = function () {
        for (var ID in this.SSBGs) {
            var ssbg = this.SSBGs[ID];
            ssbg.add_requiredSSBG(this.SSBGs);
        }
        return;
    };
    /**
    * Update bandit group, arms and values used to compute previous activity using reward r
    * @param last_interaction contains exerciseId and score. Can also contain timestamp and duration, but unnecessary.
     * This is what the front gives to ZPDES for update.
    * */
    ZpdesHssbg.prototype.update = function (last_interaction) {
        // TODO: change here when we have multiple extraSkillRelations --> loop over the different elements
        var updateOrNot = false;
        var act = {};
        // Get act id of the exercise
        //let activity_id:string = last_interaction["activityId"];
        var interactionInfo = {};
        //let act_id:string = "";
        //let activity_id:string = ""; // TODO: rendre ça plus propre
        //let objective_id:string = last_interaction["objectiveId"];
        var initialTest = false;
        // Check if this is an initial test exercise
        //if(this.initialTestMetadata && this.exercisesMetaData){ // check that initial test info exists
        //    for(let jj = 0; jj<this.exercises_ontology.length;jj++){
        //&& Array.from(this.exercises_ontology[jj]["exerciseIds"]).values().includes(last_interaction["exerciseId"]){
        //        if(this.exercises_ontology[jj]["id"]==this.initialTestMetadata["activityId"]
        //            && this.exercises_ontology[jj]["exerciseIds"].values().includes(last_interaction["exerciseId"])){ // todo: check that
        //            for(let ll = 0; ll<this.exercisesMetaData.length; ll++){
        //                if(this.exercisesMetaData[ll]["id"] == last_interaction["exerciseId"]){
        //                    //activity_id = this.exercisesMetaData[last_interaction["exerciseId"]][0]["activityId"];
        //                    activity_id = this.exercisesMetaData[ll]["skillRelations"][0]["activityId"];
        //                    //objective_id = this.exercisesMetaData[last_interaction["exerciseId"]][0]["objectiveId"];
        //                    objective_id = this.exercisesMetaData[ll]["skillRelations"][0]["objectiveId"];
        //                    initialTest = true;
        //                }
        //            }
        //        }
        //    }
        //}
        // Get index of activity/objective
        //for(let ii =0; ii<this.params["graph"]["graph"][this.main_act]["subgroups"][0].length ; ii++){
        //    let obj_id = this.params["graph"]["graph"][this.main_act]["subgroups"][0][ii];
        //    for(let jj = 0; jj<this.params["graph"]["graph"][obj_id]["subgroups"][0].length; jj++){
        //        let act_id = this.params["graph"]["graph"][obj_id]["subgroups"][0][jj];
        //        if(act_id == activity_id && obj_id == objective_id){ // on update partout pareil, test initial ou pas
        //            act[this.main_act] = [ii];
        //            act[obj_id] = [jj];
        //            //activity_id = last_interaction["activityId"];
        //            updateOrNot = true;
        //        }
        //    }
        //}
        // Get activity and objective ids in the ontology + check if it is an initial test
        for (var i = 0; i < this.exercises_ontology.length; i++) {
            if (this.exercises_ontology[i]["exerciseIds"].includes(last_interaction["exerciseId"])) {
                //let act_id = this.exercises_ontology[i]["id"];
                interactionInfo["trueActivityId"] = this.exercises_ontology[i]["id"];
                if (this.initialTestMetadata && this.exercisesMetaData) {
                    if (this.initialTestMetadata["activityId"] == interactionInfo["trueActivityId"]) {
                        for (var j = 0; j < this.exercisesMetaData.length; j++) {
                            if (this.exercisesMetaData[j]["id"] == last_interaction["exerciseId"]
                                && Object.keys(this.exercisesMetaData[j]).includes("skillsRelations")
                                && this.exercisesMetaData[j]["skillsRelations"].length > 0) {
                                interactionInfo["usedActivityId"] = this.exercisesMetaData[j]["skillsRelations"][0]["activityId"];
                                //activity_id = this.exercisesMetaData["activityId"];
                                initialTest = true;
                            }
                        }
                    }
                }
                // Find indices in the ontology
                for (var j = 0; j < this.params["graph"]["graph"][this.main_act]["subgroups"][0].length; j++) {
                    var obj_id = this.params["graph"]["graph"][this.main_act]["subgroups"][0][j];
                    for (var l = 0; l < this.params["graph"]["graph"][obj_id]["subgroups"][0].length; l++) {
                        if (!initialTest) {
                            interactionInfo["usedActivityId"] = interactionInfo["trueActivityId"];
                        }
                        if (interactionInfo["usedActivityId"] == this.params["graph"]["graph"][obj_id]["subgroups"][0][l]) {
                            act[this.main_act] = [j];
                            act[obj_id] = [l];
                            if (initialTest) {
                                var moduleStatus = this.SSBGs[this.main_act].get_student_diagnostic();
                                var objStatus = this.SSBGs[obj_id].get_student_diagnostic();
                                //if(current_diag["param_state"][this.main_act][0][j] == 1
                                //    && current_diag["param_state"][obj_id][0][l] == 1){ // todo: remove when we know where the update problem is for initial test exercises
                                if (moduleStatus["param_state"][0][j] == 1
                                    && objStatus["param_state"][0][l] == 1) {
                                    // Check that the objective/activity are indeed open. Otherwise, it can break ZPDES.
                                    updateOrNot = true;
                                }
                            }
                            else {
                                updateOrNot = true;
                            }
                        }
                    }
                }
            }
        }
        if (Object.keys(this.exercises_to_pick_in).includes(interactionInfo["trueActivityId"])) { // todo: améliorer robustesse ici
            this.exercises_to_pick_in[interactionInfo["trueActivityId"]].delete(last_interaction["exerciseId"]); // on supprime toujours l'ex id du set
            this.fewLastExercises[interactionInfo["trueActivityId"]].push({
                "actId": last_interaction["exerciseId"],
                "score": last_interaction["score"]
            });
            // TODO: refactor above, the same data is stored at multiple locations
        }
        if (updateOrNot) { // TODO: to change when we know where the problem is
            //this.act_sequence["seq"].push(act);
            //this.act_sequence["ex"].push(last_interaction["exerciseId"]);
            //this.act_sequence["act"].push(last_interaction["activityId"]); // assume that initial test activities should be counted here
            if (!initialTest) { // Fill act_sequence only when it is not the initial test
                this.act_sequence["seq"].push(act);
                this.act_sequence["ex"].push(last_interaction["exerciseId"]);
                this.act_sequence["act"].push(interactionInfo["usedActivityId"]); // assume that initial test activities should NOT be counted here
                this.act_sequence["res"].push(last_interaction["score"]); // assume that initial test activities should NOT be counted here
                if (Object.keys(last_interaction).includes("timestamp") && Object.keys(last_interaction).includes("duration")) {
                    this.act_sequence["timestamp"].push(last_interaction["timestamp"]);
                    this.act_sequence["duration"].push(last_interaction["duration"]);
                }
                else {
                    this.act_sequence["timestamp"].push(null);
                    this.act_sequence["duration"].push(0);
                }
            }
            // Update ZPDES
            var result_impact = last_interaction["score"]; // this.compute_result_impact(result)
            // Update activity/objective
            for (var nameRT in act) { //} nameRT in act.keys():
                this.SSBGs[nameRT].update(act[nameRT], last_interaction["exerciseId"], result_impact, initialTest);
            }
            for (var nameRT in act) { //.keys():
                this.SSBGs[nameRT].promote(initialTest);
            }
            // Update exercises lists
            if (!initialTest) {
                if (this.exercises_to_pick_in[interactionInfo["trueActivityId"]].size == 0) {
                    //this.exercises_to_pick_in[this.params["graph"]["graph"][this.main_act]["subgroups"][0][act[this.main_act][0]]] = new Set();
                    //this.exercises_to_pick_in[activity_id] = new Set();
                    //for (let val in this.exercises_ontology[this.params["graph"]["graph"][this.main_act]["subgroups"][0][act[this.main_act][0]]]["exerciseIDs"]){
                    for (var ii = 0; ii < this.exercises_ontology.length; ii++) {
                        if (this.exercises_ontology[ii]["id"] == interactionInfo["trueActivityId"]) {
                            this.exercises_to_pick_in[interactionInfo["trueActivityId"]] = new Set(this.exercises_ontology[ii]["exerciseIds"]);
                        }
                    }
                }
            }
        }
        console.log(this.get_full_diagnostic());
        return;
    };
    /**
    * Update based on history of past interactions
    * @param past_history : list of (ex_id,score) tuples, they should be chronologically ordered
    **/
    ZpdesHssbg.prototype.update_history = function (past_history) {
        for (var nn = 0; nn < past_history.length; nn++) {
            this.update(past_history[nn]);
        }
        return;
    };
    /**
    * Main function to be called to generate the activity to propose to the learner based on the ZPD and the learning progress
    * It calls speSample function on the prime bandit group which will recursively select the bandit value to compose the activity to propose
    * @returns the complete set of parameters values which identify an activity
    */
    ZpdesHssbg.prototype.sample = function () {
        var act = this.speSample(this.SSBGs[this.main_act], undefined);
        return act; // act is an Object. It will have a field with the module id (value: index of the obj) and a field with the obj id (value: index of the act in the obj)
    };
    /**
     * Sample from anywhere in the graph. Used for proposing random exercises to the student when they have finished
     * the module.
     */
    ZpdesHssbg.prototype.sample_from_anywhere = function () {
        var objectives_to_pick_in = this.params["graph"]["graph"][this.main_act]["subgroups"][0];
        var obj = objectives_to_pick_in[Math.floor(Math.random() * objectives_to_pick_in.length)];
        var activities_to_pick_in = this.params["graph"]["graph"][obj]["subgroups"][0];
        var act = activities_to_pick_in[Math.floor(Math.random() * activities_to_pick_in.length)];
        return [obj, act];
    };
    /**
    * Function used to choose a random exercise id based on a list of exercises to pick in + the chosen activity id
    * This implements a round robin strategy for cycling the exercises concerning a given activity
    * @param exercises_to_choose: dictionary with activity id as keys and the list of exercises that can be chosen at a given time as values
    * @param activity_id: UUID of the activity that was chosen by the algorithm
     * @param minExGap: minimum number of exercises to have between two occurrences of the same exercise in a given activity
    **/
    ZpdesHssbg.prototype.randomExercise = function (exercises_to_choose, activity_id, minExGap) {
        var clonedExercisesToChoose = lodash_clonedeep_1.default(exercises_to_choose);
        //let list_of_exos = Array.from(exercises_to_choose[activity_id].values());
        if (this.fewLastExercises[activity_id].length > minExGap && clonedExercisesToChoose[activity_id].size > minExGap) {
            for (var i = this.fewLastExercises[activity_id].length - 1; i >= this.fewLastExercises[activity_id].length - 1 - minExGap; i--) {
                // Heuristic for maintaining a gap of minExGap exercises between two occurrences of the same ex in a given act
                clonedExercisesToChoose[activity_id].delete(this.fewLastExercises[activity_id][i]["actId"]);
            }
        }
        var list_of_exos = Array.from(clonedExercisesToChoose[activity_id].values());
        var chosen_ex = list_of_exos[Math.floor(Math.random() * list_of_exos.length)];
        return chosen_ex;
    };
    ;
    /** Check if the initial test has been completed by the student or not.
     *
     */
    ZpdesHssbg.prototype.getInitialTestStatus = function () {
        var initialTestDone = true;
        if (this.initialTestMetadata && this.exercisesMetaData) { // p-e enlever la condition sur les exercisesMetaData ?
            if (Object.keys(this.exercises_to_pick_in).includes(this.initialTestMetadata["activityId"])) {
                if (this.exercises_to_pick_in[this.initialTestMetadata["activityId"]].size > 0) {
                    initialTestDone = false;
                }
            }
        }
        return initialTestDone;
    };
    /**
    Sample exercise based on past list of interactions. Combines this.update_history, this.sample and this.randomExercise
    **/
    ZpdesHssbg.prototype.sample_from_history = function (past_history) {
        // Update history
        this.update_history(past_history);
        // By default, regular sample
        var isModuleFinished = this.getModuleStatus();
        var act = this.sample();
        var obj_id = this.get_obj_id(act);
        var act_id = this.get_act_id(act, obj_id);
        if (isModuleFinished) {
            var res = this.sample_from_anywhere();
            obj_id = res[0];
            act_id = res[1];
        }
        //Transform activity id
        //let obj_id = this.params["graph"]["graph"][this.main_act]["subgroups"][0][act[this.main_act]];
        //let act_id = this.params["graph"]["graph"][obj_id]["subgroups"][0][act[obj_id]];
        //let act_index = act[obj_id];
        //let ex = this.randomExercise(this.exercises_to_pick_in,this.params["graph"]["graph"][obj_id]["subgroups"][0][act_index]);
        var ex = this.randomExercise(this.exercises_to_pick_in, act_id, 2);
        var isInitialTest = false;
        if (!this.getInitialTestStatus() // if initial test not finished, sample next exercise in list
            && Object.keys(this.exercises_to_pick_in).includes(this.initialTestMetadata["activityId"])) { // to test
            act_id = this.initialTestMetadata["activityId"];
            obj_id = this.initialTestMetadata["objectiveId"];
            ex = Array.from(this.exercises_to_pick_in[act_id].values())[0]; // get next exercise in the list of initial test exercises
            isInitialTest = true;
        }
        var output = { "moduleId": this.main_act,
            "objectiveId": obj_id,
            "activityId": act_id,
            "exerciseId": ex,
            "isInitialTest": isInitialTest,
            "isModuleFinished": isModuleFinished
        };
        return output;
    };
    ZpdesHssbg.prototype.get_obj_id = function (act) {
        return this.params["graph"]["graph"][this.main_act]["subgroups"][0][act[this.main_act]];
    };
    ZpdesHssbg.prototype.get_act_id = function (act, obj_id) {
        return this.params["graph"]["graph"][obj_id]["subgroups"][0][act[obj_id]];
    };
    /**
    * Function called by sample function, it is the function that will recursively select the parameters value of the activity from the primary bandit group given.
    * @param ssbgToS bandit group to be sampled
    * @param act object in which the activity computed with the selected parameter values is stored
    * @returns the parameter values selected for ssbgToS and for all sub dependent ssbgs
    */
    ZpdesHssbg.prototype.speSample = function (ssbgToS, act) {
        if (act == undefined)
            act = {};
        act[ssbgToS.ID] = ssbgToS.sample();
        for (var actRT = 0; actRT < act[ssbgToS.ID].length; actRT++) {
            var hierar = ssbgToS.values_children[actRT][act[ssbgToS.ID][actRT]];
            if (hierar) {
                var nameRT = ssbgToS.param_values[actRT][act[ssbgToS.ID][actRT]];
                this.speSample(this.SSBGs[nameRT], act);
            }
        }
        return act;
    };
    ZpdesHssbg.prototype.getModuleStatus = function () {
        /**
         * Return status of the module: completed or not completed
         * We only check if the last objective has been completed and we don't care about the specific activities in this obj.
         **/
        var moduleState = this.SSBGs[this.main_act].get_student_diagnostic()["param_state"][0];
        var isModuleFinished = moduleState.every(function (objStatus) { return objStatus == 2; });
        return isModuleFinished;
    };
    // TO TEST
    /**
    * Return active values for prof dashboard
    * @returns active values for prof dashboard
    */
    ZpdesHssbg.prototype.get_active_bandits = function () {
        var active_ssbgs = {};
        for (var ID in this.SSBGs) {
            active_ssbgs[ID] = this.SSBGs[ID].get_active_bandits();
        }
        return active_ssbgs;
    };
    /**
    * Set the bypass vector with prof needs: unused in Athena for now
    * @bypass_val value correspond to prof needs
    */
    ZpdesHssbg.prototype.set_bypass_prof = function (bypass_val) {
        for (var ID in this.SSBGs) {
            this.SSBGs[ID].set_bypass_prof(bypass_val[ID]);
        }
    };
    /**
    * Reset bypass vector to have no bypass: unused in Athena for now
    */
    ZpdesHssbg.prototype.reset_bypass_prof = function () {
        for (var ID in this.SSBGs) {
            this.SSBGs[ID].reset_bypass_prof();
        }
    };
    /**
    * Force ZPD by prof bypass, to do ?
    */
    ZpdesHssbg.prototype.tmp_force_ZPD = function (constrain) {
    };
    return ZpdesHssbg;
}());
exports.default = ZpdesHssbg;
var ZpdesSsbg = /** @class */ (function () {
    /**
    * Constructor of ssbg class: ssbg means strategic student bandit group
     * A group of bandits can have multiple types of bandits: one that can choose the color of the background of the
     * exercise, one that can choose the range of numbers for the exo... in Athena, we only have two types of bandit
     * groups: one at the objective level and one at the activity level. Each group is composed of one bandit with multiple
     * arms: one for each value (for instance, one for each activity of an objective). So this class deals with the
     * intermediate level in ZPDES: the level of the bandit group, but it is not really useful for us since each bandit
     * group has only one bandit inside.
    * @param params all parameters for ssbg
    */
    function ZpdesSsbg(params) {
        this.godmode = false;
        this.params = params;
        var graph_def = params["graph_def"];
        this.ID = graph_def["current_ssbg"];
        var ssbg_def = graph_def[this.ID];
        if (Object.keys(ssbg_def).includes("subgroups")) {
            ssbg_def["ssbg"] = ssbg_def["subgroups"];
        }
        this.nactions = ssbg_def["ssbg"].length;
        this.act = [];
        this.nbturn = [];
        this.nb_stay = [];
        this.requirements = [];
        this.min_nb_ans_lp = [];
        this.param_values = []; //[] for i in range(this.nactions)]
        this.values_children = []; //[] for i in range(this.nactions)]
        this.nvalue = [];
        //this.expected_actual_progression_speed = {"progression":[]};
        //this.stepUpdate = [];
        for (var i = 0; i < this.nactions; i++) {
            this.act.push(0);
            this.nbturn.push(0);
            this.param_values.push([]);
            this.values_children.push([]);
            // init for paramters for hierarchical stuff
            //console.log('ssbg const ssbg', ssbg_def["ssbg"][i]);
            this.nvalue.push(ssbg_def["ssbg"][i].length);
            for (var _i = 0, _a = ssbg_def["ssbg"][i]; _i < _a.length; _i++) {
                var val = _a[_i];
                // If value in graph_def add 1 to values_children to generate a new SSBG
                //console.log('ssbg const', this.ID, graph_def, val);
                this.values_children[i].push(Number(val in graph_def));
                this.param_values[i].push(val);
            }
        }
        // Start of definitions of ssbg params with default values 
        if (Object.keys(ssbg_def).includes("init_ssb")) {
            this.init_ssb = ssbg_def["init_ssb"];
        }
        else {
            this.init_ssb = []; /*[0] for x in range(this.nactions)];*/
            for (var i = 0; i < this.nactions; i++) {
                this.init_ssb.push([0]);
            }
        }
        this.h_actions = [];
        if (Object.keys(ssbg_def).includes("h")) {
            for (var i = 0; i < this.nactions; i++)
                this.h_actions.push(Boolean(ssbg_def["h"][i]));
        }
        else if (Object.keys(ssbg_def).includes("ordered")) {
            for (var i = 0; i < this.nactions; i++)
                this.h_actions.push(Boolean(ssbg_def["ordered"][i]));
        }
        else {
            for (var i = 0; i < this.nactions; i++)
                this.h_actions.push(false);
        }
        if (Object.keys(ssbg_def).includes("actions")) {
            this.actions = ssbg_def["actions"];
        }
        else {
            this.actions = [];
            for (var i = 0; i < this.nactions; i++) {
                this.actions.push("".concat(String(this.ID), "_act_", String(i)));
            }
        }
        if (Object.keys(ssbg_def).includes("nb_stay")) {
            this.nb_stay = ssbg_def["nb_stay"];
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                var nstayTemp = [];
                for (var ii = 0; ii < this.nvalue[i]; ii++) {
                    nstayTemp.push(1);
                }
                this.nb_stay.push(nstayTemp);
            }
        }
        this.do_h_promote = [];
        if (Object.keys(ssbg_def).includes("do_h_promote")) {
            for (var i = 0; i < this.nactions; i++) {
                this.do_h_promote.push(Boolean(ssbg_def["do_h_promote"][i]));
            }
        }
        else if (Object.keys(ssbg_def).includes("activation_h")) {
            for (var i = 0; i < this.nactions; i++) {
                this.do_h_promote.push(Boolean(ssbg_def["activation_h"][i]));
            }
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.do_h_promote.push(false);
            }
        }
        if (Object.keys(ssbg_def).includes("requirements")) {
            this.requirements = ssbg_def["requirements"];
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.requirements.push({});
            }
        }
        if (Object.keys(ssbg_def).includes("min_nb_ans_lp")) {
            this.min_nb_ans_lp = ssbg_def["min_nb_ans_lp"];
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.min_nb_ans_lp.push(3);
            }
        }
        this.stepMax = [];
        if (Object.keys(ssbg_def).includes("stepMax")) {
            var sm = ssbg_def["stepMax"];
            if (Array.isArray(sm) == false) {
                for (var i = 0; i < this.nactions; i++) {
                    this.stepMax.push(sm);
                }
            }
            else {
                this.stepMax = sm;
            }
        }
        // else{
        //     for(let i = 0; i < this.nactions; i++) {
        //         this.stepMax.push(this.params["ZpdesSsb"]["stepMax"]);
        //     }
        // }
        this.stepUpdate = [];
        if (Object.keys(ssbg_def).includes("stepUpdate")) {
            var su = ssbg_def["stepUpdate"];
            if (Array.isArray(su) == false) {
                for (var i = 0; i < this.nactions; i++) {
                    this.stepUpdate.push(su);
                }
            }
            else {
                this.stepUpdate = su;
            }
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.stepUpdate.push(this.params["ZpdesSsb"]["stepUpdate"]);
            }
        }
        this.nbMinStep = [];
        if (Object.keys(ssbg_def).includes("nbMinStep")) {
            var sm = ssbg_def["nbMinStep"];
            if (Array.isArray(sm) == false) {
                for (var i = 0; i < this.nactions; i++) {
                    this.nbMinStep.push(sm);
                }
            }
            else {
                this.nbMinStep = sm;
            }
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.nbMinStep.push(this.params["ZpdesSsb"]["nbMinStep"]);
            }
        }
        this.upZPDval = [];
        if (Object.keys(ssbg_def).includes("upZPDval")) {
            var uz = ssbg_def["upZPDval"];
            if (Array.isArray(uz) == false) {
                for (var i = 0; i < this.nactions; i++) {
                    this.upZPDval.push(uz);
                }
            }
            else {
                this.upZPDval = uz;
            }
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.upZPDval.push(this.params["ZpdesSsb"]["upZPDval"]);
            }
        }
        this.deactZPDval = [];
        if (Object.keys(ssbg_def).includes("deactZPDval")) {
            var dz = ssbg_def["deactZPDval"];
            if (Array.isArray(dz) == false) {
                for (var i = 0; i < this.nactions; i++) {
                    this.deactZPDval.push(dz);
                }
            }
            else {
                this.deactZPDval = dz;
            }
        }
        else {
            for (var i = 0; i < this.nactions; i++) {
                this.deactZPDval.push(this.params["ZpdesSsb"]["deactZPDval"]);
            }
        }
        // this.upZPDval = [];
        // if(Object.keys(ssbg_def).includes("upZPDval") ){
        //     let su = ssbg_def["upZPDval"];
        //     if(Array.isArray(su) == false){
        //         for(let i = 0; i < this.nactions; i++){
        //             this.upZPDval.push(su);
        //         }
        //     }
        //     else{
        //         this.upZPDval = su;
        //     }
        // }
        // else{
        //     for(let i = 0; i < this.nactions; i++) {
        //         this.upZPDval.push(this.params["ZpdesSsb"]["upZPDval"]);
        //     }
        // }
        // this.deactZPDval = [];
        // if(Object.keys(ssbg_def).includes("deactZPDval") ){
        //     let su = ssbg_def["deactZPDval"];
        //     if(Array.isArray(su) == false){
        //         for(let i = 0; i < this.nactions; i++){
        //             this.deactZPDval.push(su);
        //         }
        //     }
        //     else{
        //         this.deactZPDval = su;
        //     }
        // }
        // else{
        //     for(let i = 0; i < this.nactions; i++) {
        //         this.deactZPDval.push(this.params["ZpdesSsb"]["deactZPDval"]);
        //     }
        // }
        // Create sub bandit swith their own parameters
        this.SSB = [];
        if (this.stepMax.length == 0) {
            for (var ii = 0; ii < this.nactions; ii++) {
                this.stepMax.push(this.stepUpdate[ii] / 2);
            }
        }
        for (var ii = 0; ii < this.nactions; ii++) {
            var ssbParams = this.params["ZpdesSsb"];
            ssbParams["init_ssb"] = this.init_ssb[ii];
            ssbParams["requirements"] = this.requirements[ii];
            ssbParams["min_nb_ans_lp"] = this.min_nb_ans_lp[ii];
            ssbParams["do_h_promote"] = this.do_h_promote[ii];
            ssbParams["upZPDval"] = this.upZPDval[ii];
            ssbParams["deactZPDval"] = this.deactZPDval[ii];
            ssbParams["stepUpdate"] = this.stepUpdate[ii];
            ssbParams["stepMax"] = this.stepMax[ii];
            ssbParams["nbMinStep"] = this.nbMinStep[ii];
            this.SSB.push(new ZpdesSsb(ii, this.ID, this.nvalue[ii], this.h_actions[ii], this.param_values[ii], ssbParams));
        }
    }
    /**
    * Setter of God Mod: unused in Athena for now
    * @param mod_input value of godmode
    */
    ZpdesSsbg.prototype.set_god_mode = function (mod_input) {
        if (mod_input === void 0) { mod_input = false; }
        this.godmode = mod_input;
        for (var i = 0; i < this.nactions; i++) {
            this.SSB[i].set_god_mode(mod_input);
        }
    };
    ZpdesSsbg.prototype.change_params = function (params) {
        var keys = Object.keys(params);
        var values = Object.values(params);
        for (var i = 0; i < keys.length; i++) {
            if (Array.isArray(values[i]) == false) {
                this[keys[i]] = values[i];
                for (var ii = 0; ii < this.SSB[i].length; ii++) {
                    this.SSB[ii].set_param(keys[i], values[i]);
                }
            }
            else {
                for (var ii = 0; ii < this.SSB[i].length; ii++) {
                    this.SSB[ii].set_param(keys[i], values[i][ii]);
                }
            }
        }
    };
    /**
    * Function to save ssbg state in json: unused in Athena for now
    * @returns json data formatted
    */
    ZpdesSsbg.prototype.json_save = function () {
        var saved_json = {};
        var keys = Object.keys(this);
        var values = Object.values(this);
        for (var i = 0; i < keys.length; i++) {
            if (typeof (values[i]) == "object" && Array.isArray(values[i]) == false) {
                if (keys[i] == "params") {
                    saved_json[keys[i]] = values[i];
                }
                else {
                    //console.log("in ssbg", keys[i]);
                }
            }
            else {
                if (keys[i] == "SSB") {
                    //console.log("In SSB")
                    var ssbgs_json = [];
                    for (var ii = 0; ii < values[i].length; ii++) {
                        ssbgs_json.push(this.SSB[ii].json_save());
                    }
                    saved_json["SSB"] = ssbgs_json;
                }
                else {
                    saved_json[keys[i]] = values[i];
                }
            }
        }
        return saved_json;
    };
    /**
    * Function to load ssbg state from json format: unused in Athena for now
    * @param datta_ssbg json data
    * @param SSBGs list of ssbg in the graph
    */
    ZpdesSsbg.prototype.json_load = function (data_ssbg, SSBGs) {
        var keys = Object.keys(data_ssbg);
        var values = Object.values(data_ssbg);
        for (var i = 0; i < keys.length; i++) {
            if (typeof (values[i]) == "object" && Array.isArray(values[i]) == false) {
                if (keys[i] == "params") {
                    this[keys[i]] = values[i];
                }
                else {
                    //console.log("in ssbg", keys[i]);
                }
            }
            else {
                if (keys[i] == "SSB") {
                    //console.log("In SSB")
                    //let ssbgs_json = [];
                    for (var ii = 0; ii < values[i].length; ii++) {
                        this.SSB[ii].json_load(values[i][ii], SSBGs);
                    }
                    //data_ssbg["SSB"] = ssbgs_json;
                }
                else {
                    data_ssbg[keys[i]] = values[i];
                }
            }
        }
    };
    /**
    * Compute the reward for each ssb value used during the activity
    * @param act which ssb value are used
    * @param answer_score score of the answer of the learner
    */
    ZpdesSsbg.prototype.calcul_reward = function (act, answer_score) {
        var coeff_ans = answer_score;
        var r_ES = [];
        for (var ii = 0; ii < this.nactions; ii++)
            r_ES.push(this.SSB[ii].calcul_reward_ssb(act[ii], coeff_ans));
        return r_ES;
    };
    /**
    * Building function used during alg instanciation to add "son" ssbg in the hierarchy
    * @param nact which ssb value receive has "son" ssbg
    * @param sonSSBG ssbg object to be added as a "son"
    */
    ZpdesSsbg.prototype.add_sonSSBG = function (nact, sonSSBG) {
        for (var i = 0; i < sonSSBG.SSB.length; i++) {
            var ssb = sonSSBG.SSB[i];
            if (ssb.is_hierarchical == true) {
                this.SSB[nact].add_sonSSBG(sonSSBG);
                break;
            }
        }
    };
    /**
    * Building function used during alg instanciation to add requirements dependencies with other ssbg
    * @param HSSBG all ssbgs
    */
    ZpdesSsbg.prototype.add_requiredSSBG = function (HSSBG) {
        for (var ii = 0; ii < this.nactions; ii++)
            this.add_requiredSSB(ii, HSSBG);
    };
    /**
    * Building function used during alg instanciation to add requirements dependencies with other ssbg
    * @param nact which ssb value is added required ssbg
    * @param HSSBG all ssbgs
    */
    ZpdesSsbg.prototype.add_requiredSSB = function (nact, HSSBG) {
        this.SSB[nact].add_requiredSSBG(HSSBG);
    };
    /**
    * Update bandit arms and values used to compute previous activity using reward r
    * @param act tags corresponding to the bandit arms and their values to update in the group
     * @param ex exercise id
    * @param result_impact reward depending on activity result
     * @param initialTest whether the initial test is finished or not
    */
    ZpdesSsbg.prototype.update = function (act, ex, result_impact, initialTest) {
        // First compute the reward associated with the activity and then update the bandits
        var r_ES = this.calcul_reward(act, result_impact);
        for (var ii = 0; ii < this.nactions; ii++) {
            this.nbturn[ii] += 1;
            this.SSB[ii].update(act[ii], ex, Math.max(0, r_ES[ii]), result_impact, initialTest);
        }
    };
    /**
    * Manage activation or deactivation of ssb in the ssb group --> this is used to make the ZPD evolve
     * @param initialTest whether the initial test is finished or not
    */
    ZpdesSsbg.prototype.promote = function (initialTest) {
        for (var ii = 0; ii < this.nactions; ii++)
            this.SSB[ii].promote(false, initialTest);
    };
    /**
    * Launch the selection of values for each bandit in the group
    * @returns the action values selected for each bandit to compute the activity
    */
    ZpdesSsbg.prototype.sample = function () {
        for (var i = 0; i < this.nactions; i++) {
            var nb_stay_to_test = this.nb_stay[i][this.act[i]];
            if (this.nbturn[i] % nb_stay_to_test == 0) {
                // Sample a new activity/objective if it has been nb_stay exercises with the same act/obj
                //if(randomSample == 0)
                this.act[i] = Number(this.SSB[i].sample());
                // else
                //     this.act[i] = Number(this.SSB[i].random_sample());
                this.nbturn[i] = 0;
            }
        } // otherwise stay with the same activity/objective
        return this.act;
    };
    /**
    * Get probability distribution over the each bandit of the group
    * @returns list of prob distribution for each bandit
    */
    ZpdesSsbg.prototype.get_prob_distrib = function () {
        var act_probs = [];
        for (var i = 0; i < this.nactions; i++) {
            var nb_stay_to_test = this.nb_stay[i][this.act[i]];
            if (this.nbturn[i] % 4 == 0)
                act_probs.push(this.SSB[i].get_probDistrib());
            this.nbturn[i] = 0;
        }
        return act_probs;
    };
    // TO TEST
    /**
    * Return active values for prof dashboard
    */
    ZpdesSsbg.prototype.get_active_bandits = function () {
        var active_ssb = [];
        for (var i = 0; i < this.nactions; i++) {
            active_ssb.push(this.SSB[i].active_bandits());
        }
        return active_ssb;
    };
    ZpdesSsbg.prototype.get_student_diagnostic = function () {
        var SSBGdiagnostic = { "param_state": [],
            "progression": [] };
        for (var i = 0; i < this.nactions; i++) {
            SSBGdiagnostic["param_state"].push(this.SSB[i].state_bandval);
            for (var j = 0; j < this.SSB[i].SSBdiagnostic.length; j++) {
                SSBGdiagnostic["progression"].push(this.SSB[i].SSBdiagnostic[j]);
            }
        }
        return SSBGdiagnostic;
    };
    /**
    * Set the bypass vector with prof needs: unused in Athena for now
    * @param bypass_val value correspond to prof needs
    */
    ZpdesSsbg.prototype.set_bypass_prof = function (bypass_val) {
        for (var i = 0; i < this.nactions; i++) {
            this.SSB[i].set_bypass_prof(bypass_val[i]);
        }
    };
    /**
    * Reset bypass vector to have no bypass: unused in Athena for now
    */
    ZpdesSsbg.prototype.reset_bypass_prof = function () {
        for (var i = 0; i < this.nactions; i++) {
            this.SSB[i].reset_bypass_prof();
        }
    };
    return ZpdesSsbg;
}());
var ZpdesSsb = /** @class */ (function () {
    /**
    * Constructor of ssb class
    * @param id id of the ssb
    * @param nval number of values in the bandit arm
    * @param is_h is this arm ordered
     * @param rSSBG the bandit group to which the bandit belongs (useful for knowing which objective has been sampled)
    * @param param_values
     * This SSB class deals with the lowest level in the ZPDES algorithm: the level of the bandit itself. SSB means
     * strategic student bandit. It aims at selecting the specific bandit value to select: for instance, the specific
     * activity id and the specific objective id to sample.
    */
    function ZpdesSsb(id, rSSBG, nval, is_h, param_values, params) {
        this.godmode = false;
        this.id = id;
        this.relatedSSBG = rSSBG;
        this.params = params;
        this.nval = nval;
        this.bandval = new Array(nval);
        this.bandval.fill(0.0);
        this.state_bandval = new Array(nval); // state_bandval is used to know the exact state of each bandit value: activated, deactivated or not tackled yet
        this.state_bandval.fill(0.0);
        this.rolling_average_score = new Array(nval);
        this.rolling_average_score.fill(0.5); // Used for dashboard: gives the expected student success
        this.SSBdiagnostic = [];
        this.unlockedElements = []; // Saves the elements that have been activated/unlocked due to promotion in this bandit
        this.filter1 = params.filter1;
        this.filter2 = 1 - params.filter1;
        this.uniformval = params.uniformval;
        this.success = [];
        this.bypass_prof = [];
        for (var i = 0; i < this.nval; i++) {
            this.success.push([]);
            this.bypass_prof.push(1);
        }
        this.is_hierarchical = is_h;
        this.param_values = param_values;
        this.sonSSBG = {};
        this.requiSSBG = {};
        this.HSSBG = undefined;
        this.stepUpdate = params['stepUpdate'];
        this.stepMax = params['stepMax'];
        this.nbMinStep = params['nbMinStep'];
        this.init_ssb = params["init_ssb"];
        this.upZPDval = params["upZPDval"];
        this.deactZPDval = params["deactZPDval"];
        this.promote_coeff = params["promote_coeff"];
        this.h_promote_coeff = params["h_promote_coeff"];
        this.do_h_promote = Boolean(params["do_h_promote"]);
        this.thresHProm = params["thresHProm"];
        this.thresHDeact = params["thresHDeact"];
        this.requirements = params["requirements"];
        this.min_nb_ans_lp = params["min_nb_ans_lp"];
        // Add init_ssb to state_bandval
        for (var i = 0; i < this.init_ssb.length; i++) {
            this.state_bandval[this.init_ssb[i]] = 1;
        }
        this.positive_alert_threshold = params["dashboard"]["thresPos"];
        this.negative_alert_threshold = params["dashboard"]["thresNeg"];
        this.promote(true, false);
    }
    /**
    * Setter of God Mod: unused in Athena for now
    * @param mod_input value of godmode
    */
    ZpdesSsb.prototype.set_god_mode = function (mod_input) {
        if (mod_input === void 0) { mod_input = false; }
        this.godmode = mod_input;
    };
    /**
    * Setter of ssb parameters
    * @param param_key name of the parameter to set
    * @param param_value new value of the parameter to set
    */
    ZpdesSsb.prototype.set_param = function (param_key, param_value) {
        this[param_key] = param_value;
    };
    /**
    * Function to save ssb state in json: unused in Athena for now
    * @returns json data formatted
    */
    ZpdesSsb.prototype.json_save = function () {
        var saved_json = {};
        var keys = Object.keys(this);
        var values = Object.values(this);
        for (var i = 0; i < keys.length; i++) {
            //saved_json[keys[i]] = values[i];
            if (typeof (values[i]) == "object" && Array.isArray(values[i]) == false) {
                if (["params", "requirements"].includes(keys[i])) {
                    saved_json[keys[i]] = values[i];
                }
                else if ([""].includes(keys[i])) { //"requiSSBG", sonSSBG
                    var tab_k = [];
                    for (var kk in Object.keys(values[i])) {
                        tab_k.push(kk);
                    }
                    saved_json[keys[i]] = tab_k;
                }
                else {
                    //console.log(keys[i]);
                }
            }
            else {
                saved_json[keys[i]] = values[i];
            }
        }
        return saved_json;
    };
    /**
    * Function to load ssb state from json format: unused in Athena for now
    * @param datta_ssb json data
    * @param SSBGs list of ssbg in the graph
    */
    ZpdesSsb.prototype.json_load = function (datta_ssb, SSBGs) {
        var keys = Object.keys(datta_ssb);
        var values = Object.values(datta_ssb);
        //this.reset_sonSSBG();
        for (var i = 0; i < keys.length; i++) {
            //saved_json[keys[i]] = values[i];
            if (typeof (values[i]) == "object" && Array.isArray(values[i]) == false) {
                if (["params", "requirements"].includes(keys[i])) {
                    this[keys[i]] = values[i];
                }
                else if (["sonSSBG"].includes(keys[i])) {
                    var tab_k = values[i];
                    for (var kk in Object.keys(values[i])) {
                        this.add_sonSSBG(SSBGs[kk]);
                    }
                }
                else {
                    //console.log(keys[i]);
                }
            }
            else {
                this[keys[i]] = values[i];
            }
        }
    };
    /**
    * Count the number of bandit value that have a precise value
    * @param value value with which compare the bandit values
    * @returns count of bandit value equal the entry value
    */
    ZpdesSsb.prototype.count_bandval = function (value) {
        var count = 0;
        for (var ii = 0; ii < this.bandval.length; ii++) {
            if (this.bandval[ii] == value)
                count++;
        }
        return count;
    };
    // ###############################################
    // Definition of promotion function
    // ###############################################
    /**
    * Promotion of bandit values based on hierarchical structure with or without requirements --> in Athena, used for objective promotion
    */
    ZpdesSsb.prototype.hierarchical_promote_async = function () {
        /* To test with ssbg and hssg */
        for (var i = 0; i < this.nval; i++) {
            var paramID = this.param_values[i];
            var requi = this.requirements;
            if (paramID in requi) { // hard-coded requirement for activation of objective
                var reqSuccRate = [];
                for (var pv in requi[paramID]) {
                    //let ssbgTreat = this.sonSSBG[pv];
                    //console.log("hpa : in shr 1");
                    //let ssbgTreatSuccRate = this.requi_hsuccess_rate({ssbg: ssbgTreat, first_step: -this.stepMax, min_nb_ans: this.nbMinStep, val: [requi[paramID][pv]["lvl"]]})
                    //console.log("hpa : out shr 1");
                    //let b = ssbgTreatSuccRate >= requi[paramID][pv]["sr"][j];
                    //reqSuccRate.push(b ? 1 : 0);
                    /*reqSuccRate.push(int(ssbgTreatSuccRate >= requi[paramID][pv]["sr"]));*/
                    for (var j = 0; j < requi[paramID][pv]["lvl"].length; j++) { // loop over levels and success rates for a *given* activity/objective
                        var ssbgTreat = this.sonSSBG[pv];
                        //console.log("hpa : in shr 1");
                        var ssbgTreatSuccRate = this.requi_hsuccess_rate({ ssbg: ssbgTreat, first_step: -this.stepMax, min_nb_ans: this.nbMinStep, val: [requi[paramID][pv]["lvl"][j]] });
                        //console.log("hpa : out shr 1");
                        var b = ssbgTreatSuccRate >= requi[paramID][pv]["sr"][j];
                        reqSuccRate.push(b ? 1 : 0);
                        /*reqSuccRate.push(int(ssbgTreatSuccRate >= requi[paramID][pv]["sr"]));*/
                    }
                }
                if (zpdes_tools_1.func_sum(reqSuccRate) == reqSuccRate.length) {
                    console.log(i);
                }
                if (this.bandval[i] == 0 && zpdes_tools_1.func_sum(reqSuccRate) == reqSuccRate.length && this.len_success()[i] == 0) {
                    this.bandval[i] = Math.max.apply(Math, this.bandval) * this.h_promote_coeff;
                    this.state_bandval[i] = 1;
                    this.unlockedElements.push(i);
                    //this.bandval[i] = this.bandval[i - 1] * this.h_promote_coeff;
                }
            }
            /* Classical requirement update */
            //else{
            //console.log("not in paramID hpa")
            else if (i != 0) {
                // Classical activation for objective (without hard-coded requi)
                var ssbgi1 = this.sonSSBG[this.param_values[i - 1]];
                var tabTabSucessRatei1 = this.hsuccess_rate({ ssbg: ssbgi1, first_step: -this.stepMax });
                var tabMeanSucessRatei1 = [];
                var sumSucessi1 = 0;
                for (var _i = 0, tabTabSucessRatei1_1 = tabTabSucessRatei1; _i < tabTabSucessRatei1_1.length; _i++) { /*}  = 0; tab < tabTabSucessRatei1.length; tab++){*/
                    var tab = tabTabSucessRatei1_1[_i];
                    var sum = 0;
                    for (var ii = 0; ii < tab.length; ii++) {
                        sum += tab[ii];
                    }
                    var mean = 1.0 * sum / (tab.length);
                    tabMeanSucessRatei1.push(mean);
                    sumSucessi1 += mean;
                }
                var meanSucessi1 = sumSucessi1 / tabMeanSucessRatei1.length;
                /*let meanSucessi1 = np.func_mean(tabMeanSucessRatei1);*/
                if (this.bandval[i] == 0 && this.len_success()[i] == 0 && meanSucessi1 > this.thresHProm && !(paramID in requi)) {
                    this.bandval[i] = Math.max.apply(Math, this.bandval) * this.h_promote_coeff;
                    this.state_bandval[i] = 1;
                    this.unlockedElements.push(i);
                    //this.bandval[i] = this.bandval[i - 1] * this.h_promote_coeff;
                }
            }
            var ssbgi = this.sonSSBG[this.param_values[i]];
            var tabTabSucessRatei = this.hsuccess_rate({ ssbg: ssbgi, first_step: -this.nbMinStep, min_nb_ans: this.nbMinStep });
            var minTabTemp = [];
            for (var _a = 0, tabTabSucessRatei_1 = tabTabSucessRatei; _a < tabTabSucessRatei_1.length; _a++) { /*} = 0; tab < tabTabSucessRatei.length; tab++){*/
                var tab = tabTabSucessRatei_1[_a];
                var minTemp = Math.min.apply(Math, tab);
                minTabTemp.push(minTemp);
            }
            var minTabTabSucessRatei = Math.min.apply(Math, minTabTemp); /*[Math.min(...tab) for tab in tabTabSucessRatei]);*/
            if (this.bandval[i] != 0 && minTabTabSucessRatei > this.thresHDeact) { // Deactivation of objective
                this.state_bandval[i] = 2;
                if (this.count_bandval(0) < this.bandval.length - 1) {
                    // if(this.bandval[i] != 0 && minTabTabSucessRatei > this.thresHDeact && this.count_bandval(0) < this.bandval.length - 1){
                    // if(this.bandval[i] != 0 && minTabTabSucessRatei > this.thresHDeact){ // Removed for end of module
                    // Just here because we only need to know if all objectives have been closed or not
                    this.bandval[i] = 0;
                    // this.state_bandval[i] = 2;
                }
            }
            //}
        }
    };
    /**
    * Promotion of bandit values based on requirements
    * @param i bandit value to promote
    * @returns if promotion has been done using a requirement
    */
    ZpdesSsb.prototype.requirements_promote = function (i) {
        var paramID = String(i);
        var requi = this.requirements;
        var paramIDs = this.param_values[i];
        console.log(this.state_bandval);
        if (paramID in requi) {
            var reqSuccRate = [];
            //for(let  pv in requi[paramID]){
            //    let ssbgTreat = this.requiSSBG[pv];
            //    let ssbgTreatSuccRate = this.requi_hsuccess_rate({ssbg: ssbgTreat, first_step: -this.stepMax, min_nb_ans: this.nbMinStep, val: [requi[paramID][pv]["lvl"]]});
            //    let b = ssbgTreatSuccRate >= requi[paramID][pv]["sr"];
            //    reqSuccRate.push(b ? 1 : 0);
            //}
            //for(let  pv in requi[paramID]){
            for (var pv in requi[paramID]) {
                //for(let j=0; j<requi[paramID][pv]["lvl"].length; j++){ // loop over levels and success rates for a *given* activity/objective (test)
                for (var j = 0; j < requi[paramID][pv]["lvl"].length; j++) { // loop over levels and success rates for a *given* activity/objective (test)
                    var ssbgTreat = this.requiSSBG[pv];
                    //let ssbgTreatSuccRate = this.requi_hsuccess_rate({ssbg: ssbgTreat, first_step: -this.stepMax, min_nb_ans: this.nbMinStep, val: [requi[paramID][pv]["lvl"][j]]});
                    var ssbgTreatSuccRate = this.requi_hsuccess_rate({ ssbg: ssbgTreat, first_step: -this.stepMax, min_nb_ans: this.nbMinStep, val: [requi[paramID][pv]["lvl"][j]] });
                    //let b = ssbgTreatSuccRate >= requi[paramID][pv]["sr"][j];
                    var b = ssbgTreatSuccRate >= requi[paramID][pv]["sr"][j];
                    reqSuccRate.push(b ? 1 : 0);
                }
            }
            if (this.bandval[i] == 0 && zpdes_tools_1.func_sum(reqSuccRate) == reqSuccRate.length && this.len_success()[i] == 0) {
                this.bandval[i] = Math.max.apply(Math, this.bandval) * this.h_promote_coeff;
                this.state_bandval[i] = 1;
                this.unlockedElements.push(i);
                //this.bandval[i] = this.bandval[i - 1] * this.h_promote_coeff;
            }
            else if (zpdes_tools_1.func_sum(reqSuccRate) < reqSuccRate.length) {
                this.bandval[i] = 0;
                var ii = 0;
                for (var pv in requi[paramID]) { // maybe there will be an issue with the fact that we changed the structure of requirements (arrays now)
                    /* if a value need requirements to be activated, the bandit value of this requirement will be increased */
                    if ("improve" in requi[paramID][pv] && reqSuccRate[ii] == 0) {
                        var toimprove = requi[paramID][pv]["improve"];
                        for (var key in toimprove) {
                            var bv = toimprove[key];
                            this.HSSBG[key].SSB[bv[0]].bandval[bv[1]] = Math.max.apply(Math, this.HSSBG[key].SSB[bv[0]].bandval);
                        }
                    }
                    ii += 1;
                }
            }
            return 1;
        }
        else if (paramIDs in requi) {
            var reqSuccRate = [];
            //for(let  pv in requi[paramIDs]){
            //    let ssbgTreat = this.requiSSBG[pv];
            //    let ssbgTreatSuccRate = this.requi_hsuccess_rate({ssbg: ssbgTreat, first_step: -this.stepMax, val: [requi[paramIDs][pv]["lvl"]]});
            //    let b = ssbgTreatSuccRate >= requi[paramIDs][pv]["sr"];
            //    reqSuccRate.push(b ? 1 : 0);
            //}
            for (var pv in requi[paramIDs]) {
                for (var j = 0; j < requi[paramIDs][pv]["lvl"].length; j++) { // loop over levels and success rates for a *given* activity/objective
                    var ssbgTreat = this.requiSSBG[pv];
                    var ssbgTreatSuccRate = this.requi_hsuccess_rate({ ssbg: ssbgTreat, first_step: -this.stepMax, val: [requi[paramIDs][pv]["lvl"][j]] });
                    var b = ssbgTreatSuccRate >= requi[paramIDs][pv]["sr"][j];
                    reqSuccRate.push(b ? 1 : 0);
                }
            }
            if (this.bandval[i] == 0 && zpdes_tools_1.func_sum(reqSuccRate) == reqSuccRate.length && this.len_success()[i] == 0) {
                this.bandval[i] = Math.max.apply(Math, this.bandval) * this.h_promote_coeff;
                this.state_bandval[i] = 1;
                this.unlockedElements.push(i);
                //this.bandval[i] = this.bandval[i - 1] * this.h_promote_coeff;
            }
            else if (zpdes_tools_1.func_sum(reqSuccRate) < reqSuccRate.length) {
                this.bandval[i] = 0;
                var ii = 0;
                for (var pv in requi[paramIDs]) { // maybe there will be an issue with the fact that we changed the structure of requirements (arrays now)
                    /* if a value need requirements to be activated, the bandit value of this requierement will be increased */
                    if ("improve" in requi[paramIDs][pv] && reqSuccRate[ii] == 0) {
                        var toimprove = requi[paramIDs][pv]["improve"];
                        for (var key in toimprove) {
                            var bv = toimprove[key];
                            this.HSSBG[key].SSB[bv[0]].bandval[bv[1]] = Math.max.apply(Math, this.HSSBG[key].SSB[bv[0]].bandval);
                        }
                    }
                    ii += 1;
                }
            }
            return 1;
        }
        else
            return 0;
    };
    /**
    * Manage activation and deactivation of bandit values when the promotion is not hierarchically dependent of other bandit groups
     * This is the case for instance for activities: we only look at the current level (activities of the obj) for activation or deactivation
     * (except if this is a hard-coded activation requirement)
    */
    ZpdesSsb.prototype.promote_async = function () {
        var succrate_active = zpdes_tools_2.func_mean(this.success_rate({ first_step: -this.stepMax, val: this.active_bandits(), min_nb_ans: 2 }));
        //if(succrate_active > this.upZPDval && this.len_success().includes(0)){
        if (this.len_success().includes(0)) {
            var actval = this.len_success().indexOf(0);
            if (this.requirements_promote(actval) == 0 && succrate_active > this.upZPDval) {
                var tabToMax = [];
                for (var _i = 0, _a = this.active_bandits(); _i < _a.length; _i++) {
                    var x = _a[_i];
                    tabToMax.push(this.bandval[x]);
                }
                //    if(this.requirements_promote(actval) == 0){
                //    	let tabToMax = [];
                //    	for(let x of this.active_bandits()){
                //    		tabToMax.push(this.bandval[x]);
                //    	}
                this.bandval[actval] = Math.max.apply(Math, tabToMax) * this.promote_coeff;
                this.state_bandval[actval] = 1;
                this.unlockedElements.push(actval);
            }
        }
        var max_usable_val_to_deact = [];
        for (var _b = 0, _c = this.active_bandits(); _b < _c.length; _b++) {
            var x = _c[_b];
            if (this.len_success()[x] >= this.nbMinStep) {
                max_usable_val_to_deact.push(zpdes_tools_2.func_mean(this.success_rate({ first_step: -this.nbMinStep, val: [x] })));
            }
            else {
                max_usable_val_to_deact.push(0);
            }
        }
        if (max_usable_val_to_deact.length > 0) {
            var imaxd = this.active_bandits()[zpdes_tools_4.argMax(max_usable_val_to_deact)];
            var max_succrate_active_todeact = zpdes_tools_2.func_mean(this.success_rate({ first_step: -this.nbMinStep, val: [imaxd] }));
            /*# imaxd != )this.nval-1:*/
            // deactivate a bandit value when the success rate over the zpd is abos threhold and the number of active bandit is at least 1 : todo meca to keep a least something mastered
            // let lsss = this.len_success();
            // let isL = 0;
            // for(let ss of lsss){
            //     if(ss > 5){
            //        isL = 1;
            //     }
            // }
            // if(isL == 1){
            //     console.log("###############");
            //     console.log("debug promote");
            //     console.log(this.relatedSSBG);
            //     console.log(this.active_bandits());
            //     console.log("maxVal", max_usable_val_to_deact);
            //     console.log("imaxd", imaxd);
            //     console.log("Len_imaxd", this.len_success()[imaxd]);
            //     console.log("minStep", this.nbMinStep);
            //     console.log("Bandval", this.bandval);
            //     console.log("maxSucActDeact", max_succrate_active_todeact);
            //     console.log("count0", this.count_bandval(0));
            //     console.log("bandLength", this.bandval.length - 1);
            //     console.log("end debug promote");
            //     console.log("###############");
            // }
            if (this.len_success()[imaxd] >= this.nbMinStep && max_succrate_active_todeact > this.deactZPDval && this.count_bandval(0) < this.bandval.length - 1) {
                // if(this.len_success()[imaxd] >= this.nbMinStep  && max_succrate_active_todeact > this.deactZPDval){ // Removed for end of module
                this.bandval[imaxd] = 0;
                this.state_bandval[imaxd] = 2;
            }
        }
    };
    /**
    * Manage activation or deactivation of ssb values. This function uses all three functions above and gathers them all
     * at one place.
    * @param init defines if the promotion functions is used during initialisation
    * @param initialTest whether the initial test is finished or not.
     */
    ZpdesSsb.prototype.promote = function (init, initialTest) {
        if (init === void 0) { init = false; }
        if (initialTest === void 0) { initialTest = false; }
        if (init == true) {
            if (this.is_hierarchical == false) {
                for (var i = 0; i < this.bandval.length; i++) {
                    this.bandval[i] = this.uniformval;
                }
            }
            else {
                for (var _i = 0, _a = this.init_ssb; _i < _a.length; _i++) {
                    var ii = _a[_i];
                    this.bandval[ii] = this.uniformval;
                }
            }
        }
        else if (this.is_hierarchical) { // hierarchical = objective level
            if (this.do_h_promote == true) {
                this.hierarchical_promote_async();
            }
            else {
                this.promote_async();
            }
            if (!initialTest) {
                // Add elements that were unlocked by the interaction
                //let lenPastProgression = this.HSSBG["SSBdiagnostic"]["progression"].length;
                var lenPastProgression = this.SSBdiagnostic.length;
                //let lenSameActSequence = this.HSSBG["SSBdiagnostic"]["progression"][lenPastProgression-1]["exercises"].length
                var lenSameActSequence = this.SSBdiagnostic[lenPastProgression - 1]["exercises"].length;
                //this.HSSBG["SSBdiagnostic"]["progression"][lenPastProgression-1]["exercises"][lenSameActSequence]["unlockedElements"] = this.unlockedElements;
                this.SSBdiagnostic[lenPastProgression - 1]["exercises"][lenSameActSequence - 1]["unlockedElements"] = this.unlockedElements;
                this.unlockedElements = [];
            }
        }
    };
    // ###############################################
    // End Definition of promotion function
    // ###############################################
    /**
    * Return ssb id which are active
    * @returns list of active bandits id
    */
    ZpdesSsb.prototype.active_bandits = function () {
        var a = [];
        for (var x = 0; x < this.nval; x++) {
            if (this.bandval[x] != 0) {
                a.push(x);
            }
        }
        return a; /*[x for x in range(this.nval) if this.bandval[x] != 0]*/
    };
    /**
    * Return ssb id which are not active
    * @returns list of non active bandits id
    */
    ZpdesSsb.prototype.not_active_bandits = function () {
        var na = [];
        for (var x = 0; x < this.nval; x++) {
            if (this.bandval[x] == 0) {
                na.push(x);
            }
        }
        return na;
    };
    /**
    * Return a list length of success for the wanted ssb
    * @param first_val first length to retrieve
    * @param last_val last length to retrieve
    * @returns list of length of success
    */
    ZpdesSsb.prototype.len_success = function (first_val, last_val) {
        if (first_val === void 0) { first_val = 0; }
        if (last_val === void 0) { last_val = undefined; }
        var tab = [];
        for (var _i = 0, _a = this.success; _i < _a.length; _i++) {
            var x = _a[_i];
            tab.push(x.length);
        }
        if (last_val == undefined) {
            last_val = tab.length;
        }
        return tab.slice(first_val, last_val);
    };
    /**
    * Compute the success rate for a specific ssb of the wanted ssbg
    * @param ssbg particular ssbg for which we want to compute the success over several ssb
    * @param first_step starting value to start to compute success rate
    * @param last_step last value to use to compute success rate
    * @param val which ssb values are used to compute the success rate
    * @param min_nb_ans minimum number of success to compute the success rate
    * @param ssb_to_sr sbb to compute the success rate
    * @returns list of success rate of ssb in ssbg given in entry
    */
    ZpdesSsb.prototype.requi_hsuccess_rate = function (_a) {
        var ssbg = _a.ssbg, _b = _a.first_step, first_step = _b === void 0 ? 0 : _b, _c = _a.last_step, last_step = _c === void 0 ? undefined : _c, _d = _a.val, val = _d === void 0 ? undefined : _d, _e = _a.min_nb_ans, min_nb_ans = _e === void 0 ? 2 : _e, _f = _a.ssb_to_sr, ssb_to_sr = _f === void 0 ? 0 : _f;
        var successUsed = ssbg.SSB[ssb_to_sr].success_rate({ first_step: first_step, last_step: last_step, min_nb_ans: min_nb_ans, val: val });
        return successUsed;
    };
    /**
    * Compute the success rate for all ssb needed if they are hard hierarchical
    * @param ssbg particular ssbg for which we want to compute the success over several ssb
    * @param first_step starting value to start to compute success rate
    * @param last_step last value to use to compute success rate
    * @param val which ssb values are used to compute the success rate
    * @param min_nb_ans minimum number of successes to compute the success rate
    * @returns list of success rate of ssb in ssbg given in entry
    */
    ZpdesSsb.prototype.hsuccess_rate = function (_a) {
        var ssbg = _a.ssbg, _b = _a.first_step, first_step = _b === void 0 ? 0 : _b, _c = _a.last_step, last_step = _c === void 0 ? undefined : _c, _d = _a.val, val = _d === void 0 ? undefined : _d, _e = _a.min_nb_ans, min_nb_ans = _e === void 0 ? 2 : _e;
        //console.log("in hr");
        var successUsed = [];
        for (var _i = 0, _f = ssbg.SSB; _i < _f.length; _i++) {
            var ssb = _f[_i];
            if (ssb.is_hierarchical == true) {
                var sr = ssb.success_rate({ first_step: first_step, last_step: last_step, min_nb_ans: min_nb_ans });
                successUsed.push(sr);
            }
        }
        return successUsed;
    };
    /**
    * Compute the success rate
    * @param first_step starting value to start to compute success rate
    * @param last_step last value to use to compute success rate
    * @param val which ssb values are used to compute the success rate
    * @param min_nb_ans minimum number of successes to compute the success rate
    * @returns list of success rate for each value analyzed
    */
    ZpdesSsb.prototype.success_rate = function (_a) {
        var _b = _a.first_step, first_step = _b === void 0 ? 0 : _b, _c = _a.last_step, last_step = _c === void 0 ? undefined : _c, _d = _a.val, val = _d === void 0 ? undefined : _d, _e = _a.min_nb_ans, min_nb_ans = _e === void 0 ? 2 : _e;
        if (val == undefined) {
            val = [];
            for (var i = 0; i < this.nval; i++) {
                val.push(i);
            }
        }
        else if (val.length == 0) {
            console.log("r0");
            return [0];
        }
        var succrate = [];
        for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
            var x = val_1[_i];
            var fs = first_step;
            if (first_step < 0 && this.success[x].length + first_step > 0) {
                fs = this.success[x].length + first_step;
            }
            else
                fs = 0;
            // else{
            //     fs = this.success[x].length - first_step;
            // }
            var ls = last_step;
            if (last_step == undefined) {
                ls = this.success[x].length;
            }
            if (this.success[x].slice(fs, ls).length < min_nb_ans) {
                succrate.push(0);
            }
            else {
                succrate.push(zpdes_tools_2.func_mean(this.success[x].slice(fs, ls)));
            }
        }
        return succrate;
        // if(succrate.length > 1 && meanAll == 1){
        //     return func_mean(succrate);
        // }
        // else if(succrate.length > 1){
        //     return succrate;
        // }
        // else{
        //     return succrate[0];
        // }
    };
    /**
    * Compute the reward/learning progress for the ssb that has been used
    * @param val
    * @param coeff_ans
    * @returns the computed reward
    */
    ZpdesSsb.prototype.calcul_reward_ssb = function (val, coeff_ans) {
        this.success[val].push(coeff_ans);
        var r = 0;
        if (this.success[val].length > this.min_nb_ans_lp) {
            var y_step = Math.min(2 * this.stepMax, this.success[val].length);
            var y_range = Math.floor(y_step / 2);
            var sum_beg = this.success[val].length - y_step;
            var sum_end = this.success[val].length - y_range;
            var sum_old = zpdes_tools_2.func_mean(this.success[val].slice(sum_beg, sum_end));
            var sum_recent = zpdes_tools_2.func_mean(this.success[val].slice(sum_end));
            r = Math.abs(sum_recent - sum_old);
        }
        else {
            r = this.bandval[val];
        }
        return r;
    };
    /**
    * Add a son ssbg which will be used
    * @param HSSBG:
    */
    ZpdesSsb.prototype.add_sonSSBG = function (sonSSBG) {
        this.sonSSBG[sonSSBG.ID] = sonSSBG;
    };
    /**
    * Reset son ssbgs when loading
    */
    ZpdesSsb.prototype.reset_sonSSBG = function () {
        this.sonSSBG = {};
    };
    /**
    * During algo instance building, link required SSBG to access information for promotion needing requirements.
    * @param HSSBG: all the ssbg groups in which the required ones will be chosen to be added in the ssbg requirement.
    */
    ZpdesSsb.prototype.add_requiredSSBG = function (HSSBG) {
        if (this.HSSBG == undefined) {
            this.HSSBG = HSSBG;
        }
        //for (let ii = 0; ii < this.nval; ii++){
        //    if (String(ii) in this.requirements){
        //        for (let key in this.requirements[String(ii)]){
        //            this.requiSSBG[key] = HSSBG[key];
        //        }
        //    }
        //    else if (this.param_values[ii] in this.requirements){
        //        for (let key in this.requirements[this.param_values[ii]]){
        //            this.requiSSBG[key] = HSSBG[key];
        //        }
        //    }
        // }
        for (var ii = 0; ii < this.nval; ii++) {
            if (String(ii) in this.requirements) {
                for (var key in this.requirements[String(ii)]) {
                    this.requiSSBG[key] = HSSBG[key];
                }
            }
            else if (this.param_values[ii] in this.requirements) {
                for (var key in this.requirements[this.param_values[ii]]) {
                    this.requiSSBG[key] = HSSBG[key];
                }
            }
        }
    };
    /**
    * Update bandit values using reward r
    * @param val id of the bandit value to update
     * @param ex id of the exercise
     * @param rawScore raw score of the student on the exercise
    * @param r reward depending on activity result
     * @param initialTest whether it is an initial test interaction
    */
    ZpdesSsb.prototype.update = function (val, ex, r, rawScore, initialTest) {
        /**
        let exp_actual_prog = {} as {
            action_id: any;
            ex_id: any;
            expected_speed: any;
            actual_speed: any;
            positive_alert: any;
            negative_alert: any;
        };
        exp_actual_prog["action_id"] = val;
        exp_actual_prog["ex_id"] = ex;
        exp_actual_prog["expected_speed"] = this.bandval[val];
        this.bandval[val] = this.filter1 * this.bandval[val] + this.filter2 * r;
        exp_actual_prog["actual_speed"] = r;
        let rel_diff = (r - this.bandval[val]) / Math.abs(this.bandval[val]);
        exp_actual_prog["positive_alert"] = false;
        exp_actual_prog["negative_alert"] = false;
        if(this.SSBdiagnostic.length > 0){
            if(rel_diff > this.positive_alert_threshold){
                this.SSBdiagnostic[this.expected_actual_progression_speed.length-1]["positive_alert"] = true;
            }
            else if(rel_diff < -this.negative_alert_threshold){
                this.expected_actual_progression_speed[this.expected_actual_progression_speed.length-1]["negative_alert"] = true;
            }
        }
        this.expected_actual_progression_speed.push(exp_actual_prog);
        **/
        if (!initialTest) {
            var exp_actual_prog = {};
            exp_actual_prog["id"] = ex;
            // Update exponential moving average: this is the expected success
            /**
            if(this.rolling_average_score[val] == -1){
                this.rolling_average_score[val] = rawScore;
            }
            else{
                this.rolling_average_score[val] = 0.5 * rawScore + 0.5 * this.rolling_average_score[val];
            }**/
            exp_actual_prog["success"] = {
                //"current": r,
                "current": rawScore,
                //"expected": this.bandval[val],
                "expected": this.rolling_average_score[val],
                "alert": "none"
            };
            // Update exponential moving average
            this.rolling_average_score[val] = 0.5 * rawScore + 0.5 * this.rolling_average_score[val];
            //rel_diff = (r - this.bandval[val]) / Math.abs(this.bandval[val]);
            //exp_actual_prog["success"]["current"] = r;
            // no positive/negative alert by default
            exp_actual_prog["breakPoint"] = {
                "improvement": false,
                "regression": false
            };
            //let lenPastProgression = this.HSSBG[this.relatedSSBG].expected_actual_progression_speed["progression"].length;
            var lenPastProgression = this.SSBdiagnostic.length; // length of past progression in the objective (activity-wise)
            var actId = val;
            if (lenPastProgression == 0) {
                //this.HSSBG["expected_actual_progression_speed"]["progression"].push({
                this.SSBdiagnostic.push({
                    "id": actId,
                    "exercises": [
                        exp_actual_prog
                    ],
                    "status": "open"
                });
            }
            else {
                // Get positive/negative alert flag
                var positiveAlert = false;
                var negativeAlert = false;
                /**if (this.bandval[val] == 0) { // when bandit value is 0, always alert if difference between expected and current
                    if (r > 0) {
                        positiveAlert = true;
                        exp_actual_prog["success"]["alert"] = "positive";
                    } else {
                        negativeAlert = true;
                        exp_actual_prog["success"]["alert"] = "negative";
                    }
                } else {
                    let rel_diff = (r - this.bandval[val]) / Math.abs(this.bandval[val]);
                    if (rel_diff > this.positive_alert_threshold) {
                        positiveAlert = true;
                        exp_actual_prog["success"]["alert"] = "positive";
                    } else if (rel_diff < -this.negative_alert_threshold) {
                        negativeAlert = true;
                        exp_actual_prog["success"]["alert"] = "negative";
                    }
                }**/
                var score_diff = rawScore - this.rolling_average_score[val];
                if (score_diff > this.positive_alert_threshold) {
                    positiveAlert = true;
                    exp_actual_prog["success"]["alert"] = "positive";
                }
                else if (score_diff < -this.negative_alert_threshold) {
                    negativeAlert = true;
                    exp_actual_prog["success"]["alert"] = "negative";
                }
                //if(this.HSSBG["expected_actual_progression_speed"]["progression"][lenPastProgression-1]["id"]!=actId){
                if (this.SSBdiagnostic[lenPastProgression - 1]["id"] != actId) {
                    //this.HSSBG["expected_actual_progression_speed"]["progression"].push({
                    this.SSBdiagnostic.push({
                        "id": actId,
                        "exercises": [
                            exp_actual_prog
                        ],
                        "status": "open"
                    });
                    if (this.state_bandval[this.SSBdiagnostic[lenPastProgression - 1]["id"]] == 2) {
                        this.SSBdiagnostic[lenPastProgression - 1]["status"] = "closed";
                    }
                    // Update last alert for same activity
                    // TODO: maybe to change, only breakpoint if the last activity practiced is the same?
                    for (var i = lenPastProgression - 1; i >= 0; i--) {
                        //if(this.HSSBG["expected_actual_progression_speed"]["progression"][i]["id"]==actId){
                        if (this.SSBdiagnostic[i]["id"] == actId) {
                            //let lenSameActSequence = this.HSSBG["expected_actual_progression_speed"]["progression"][i]["exercises"].length
                            var lenSameActSequence = this.SSBdiagnostic[i]["exercises"].length;
                            //this.HSSBG["expected_actual_progression_speed"]["progression"][i]["exercises"][lenSameActSequence-1]["breakPoint"]["improvement"] = positiveAlert;
                            this.SSBdiagnostic[i]["exercises"][lenSameActSequence - 1]["breakPoint"]["improvement"] = positiveAlert;
                            //this.HSSBG["expected_actual_progression_speed"]["progression"][i]["exercises"][lenSameActSequence-1]["breakPoint"]["regression"] = negativeAlert;
                            this.SSBdiagnostic[i]["exercises"][lenSameActSequence - 1]["breakPoint"]["regression"] = negativeAlert;
                            break;
                        }
                    }
                }
                else {
                    //this.HSSBG["expected_actual_progression_speed"]["progression"][lenPastProgression-1]["exercises"].push(exp_actual_prog);
                    this.SSBdiagnostic[lenPastProgression - 1]["exercises"].push(exp_actual_prog);
                    // Update last alert for same activity
                    //let lenSameActSequence = this.HSSBG["expected_actual_progression_speed"]["progression"][lenPastProgression-1]["exercises"].length
                    var lenSameActSequence = this.SSBdiagnostic[lenPastProgression - 1]["exercises"].length;
                    //this.HSSBG["expected_actual_progression_speed"]["progression"][lenPastProgression-1]["exercises"][lenSameActSequence-2]["breakPoint"]["improvement"] = positiveAlert;
                    this.SSBdiagnostic[lenPastProgression - 1]["exercises"][lenSameActSequence - 2]["breakPoint"]["improvement"] = positiveAlert;
                    //this.HSSBG["expected_actual_progression_speed"]["progression"][lenPastProgression-1]["exercises"][lenSameActSequence-2]["breakPoint"]["regression"] = negativeAlert;
                    this.SSBdiagnostic[lenPastProgression - 1]["exercises"][lenSameActSequence - 2]["breakPoint"]["regression"] = negativeAlert;
                }
            }
        }
        // Update bandit value: weighted average of last bandit value and new reward
        this.bandval[val] = this.filter1 * this.bandval[val] + this.filter2 * r;
    };
    /**
    * Compute probability distribution over the bandit based on bandit val and exploration coeff
    * @param exploration_coeff: coeff of exploration to manage exploration/exploitation trade-off
    * @returns probability distribution
    */
    ZpdesSsb.prototype.get_probDistrib = function (exploration_coeff) {
        if (exploration_coeff === void 0) { exploration_coeff = 10; }
        if (this.count_bandval(0) == this.bandval.length - 1) {
            // TODO: will there be an issue with end of module modification?
            for (var i = 0; i < this.bandval.length; i++) {
                if (this.bandval[i] != 0) {
                    this.bandval[i] = this.uniformval;
                }
            }
        }
        var bandval_cloned = [];
        for (var i = 0; i < this.bandval.length; i++) {
            bandval_cloned.push(this.bandval[i]);
        }
        /**let norm_v = func_sum(bandval_cloned);*/
        var norm_v = 0;
        var temp_prob = [];
        for (var i = 0; i < bandval_cloned.length; i++) {
            norm_v += bandval_cloned[i];
        }
        for (var i = 0; i < bandval_cloned.length; i++) {
            var nval = 0;
            if (bandval_cloned[i] > 0) {
                nval = bandval_cloned[i] + norm_v / exploration_coeff;
            }
            temp_prob.push(nval);
        }
        var sum_nn = 0;
        for (var i = 0; i < temp_prob.length; i++) {
            sum_nn += temp_prob[i];
        }
        var final_prob = [];
        for (var i = 0; i < temp_prob.length; i++) {
            var nval = temp_prob[i] / sum_nn;
            final_prob.push(nval);
        }
        return final_prob;
    };
    /**
    * Select the parameter value to use depending of bandit value
    * @param exploration_coeff: coeff of exploration to manage exploration/exploitation trade-off
    * @returns the action value that will be used to compute the activity
    */
    ZpdesSsb.prototype.sample = function (exploration_coeff) {
        if (exploration_coeff === void 0) { exploration_coeff = 10; }
        var origin_prob = this.get_probDistrib(exploration_coeff);
        var cumulProb = [];
        cumulProb.push(origin_prob[0]);
        for (var i = 1; i < origin_prob.length; i++) {
            cumulProb.push(cumulProb[i - 1] + origin_prob[i]);
        }
        var act = cumulProb.length - 1;
        var mr = Math.random();
        for (var i = 0; i < cumulProb.length; i++) {
            if (mr < cumulProb[i]) {
                act = i;
                break;
            }
        }
        // let arrayPoss: number[] = []; 
        // for(let i = 0; i < prob.length; i++){
        // 	let nbi = prob[i] * 100;
        // 	for(let ii = 0; ii < nbi; ii++){
        // 		arrayPoss.push(i);
        // 	}
        // }
        // let idx = Math.floor(Math.random() * arrayPoss.length);      
        return act;
    };
    // TO TEST
    /**
    * Set the bypass vector with prof needs
    * @bypass_val value correspond to prof needs
    */
    ZpdesSsb.prototype.set_bypass_prof = function (bypass_val) {
        this.bypass_prof = bypass_val;
    };
    /**
    * Reset bypass vector to have no bypass
    */
    ZpdesSsb.prototype.reset_bypass_prof = function () {
        this.bypass_prof = [];
        for (var i = 0; i < this.nval; i++) {
            this.bypass_prof.push(1);
        }
    };
    return ZpdesSsb;
}());
